import { createSlice } from "@reduxjs/toolkit";
import { IAboutState } from "./aboutModel";
import {
  updateAboutDetails,
  getAboutDetails,
  uploadAboutFacilities,
  deleteAboutFacility,
} from "./services/about.services";

const initialState: IAboutState = {
  loading: false,
  error: "",
  FacilityID: null,
  AboutDetails: {
    Title: "",
    Description: "",
    Experience: null,
    AlterTag: "",
    AboutImage: "",
    FacilityList: [],
  },
  AboutFacilityDetails: {
    FacilityTitle: "",
    FacilityIcon: "",
  },
};

const aboutSlice = createSlice({
  name: "about",
  initialState,
  reducers: {
    setFacilityID: (state, action) => {
      state.FacilityID = action.payload;
    },
    clearFacilityID: (state) => {
      state.FacilityID = initialState.FacilityID;
    },
    setAboutFacilityDetails: (state, action) => {
      state.AboutFacilityDetails = action.payload;
    },
    clearAboutFacilityDetails: (state) => {
      state.AboutFacilityDetails = initialState.AboutFacilityDetails;
    },
    clearAboutDetails: (state) => {
      state.AboutDetails = initialState.AboutDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAboutDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAboutDetails.fulfilled, (state, action: any) => {
      state.loading = false;
      state.AboutDetails = action.payload;
    });
    builder.addCase(getAboutDetails.rejected, (state, action) => {
      state.loading = false;
      state.AboutDetails = initialState.AboutDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateAboutDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateAboutDetails.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateAboutDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(uploadAboutFacilities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(uploadAboutFacilities.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(uploadAboutFacilities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteAboutFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAboutFacility.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAboutFacility.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const {
  clearAboutDetails,
  setAboutFacilityDetails,
  clearAboutFacilityDetails,
  setFacilityID,
  clearFacilityID,
} = aboutSlice.actions;
export default aboutSlice.reducer;
